import { render, staticRenderFns } from "./LegacyPage.vue?vue&type=template&id=e52e1d78&scoped=true&"
import script from "./LegacyPage.vue?vue&type=script&lang=js&"
export * from "./LegacyPage.vue?vue&type=script&lang=js&"
import style0 from "./LegacyPage.vue?vue&type=style&index=0&id=e52e1d78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52e1d78",
  null
  
)

export default component.exports